export default __webpack_public_path__ + "38a1f93e2842f9581c1f7ffd840dd522.png";